// extracted by mini-css-extract-plugin
module.exports = {"LayoutView":"styles_LayoutView__1Qgx1","shimmer":"styles_shimmer__3XaRR","empty":"styles_empty__2Z4Vq"};